// The game board on a computer's large screen (owner's request, October 2026): the table's cards are
// bigger (TableCombinations). Phones, tablets (touch) and the Android / iOS apps keep theirs.
import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";

const QUERY = "(min-width: 1024px) and (hover: hover) and (pointer: fine)";
const NATIVE = Capacitor.isNativePlatform();

export const isDesktop = () =>
  !NATIVE && typeof window !== "undefined" && !!window.matchMedia?.(QUERY).matches;

/** Whether the board uses its desktop layout; follows the window when it is resized. */
export function useDesktop() {
  const [desktop, setDesktop] = useState(isDesktop);
  useEffect(() => {
    if (NATIVE || !window.matchMedia) return undefined;
    const mq = window.matchMedia(QUERY);
    const update = () => setDesktop(mq.matches);
    update();
    mq.addEventListener?.("change", update);
    return () => mq.removeEventListener?.("change", update);
  }, []);
  return desktop;
}
